<template>
  <div class="banner-home" :style="boxStyle">
    <div v-if="loading" class="loading"></div>
    <div v-else class="container">
      <div class="image"><img :src="data.image"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      data: {},
      boxStyle: {}
    }
  },

  methods: {
    load(){
      this.loading = true;
      this.$api.get('/v1/banner_home')
        .then(({body}) => {
          this.data = body.rows[0];
          this.boxStyle['background-image'] = `url(${this.data.bg})`;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },

  created(){
    this.load();
  }
}
</script>

<style lang="scss" scoped>
.banner-home
{
  background-size: cover;
  background-repeat: no-repeat;
  border-top: 2px solid $white;
  flex-grow: 0 !important;

  IMG
  {
    display: block;
    margin: 0 auto;
    padding: 0 $lf-margin;
  }

}
</style>